export interface AppConfig {
    id: string,
    default_billing_strategy: string
    free_trial_length: number
    stripe_public_key: string,
    title: string,
    stereo_mode: "anaglyph" | "see3d",
    subscription_first: boolean,
    regimen_progress_expires: string, // "midnight" or "indefinite"
    allow_clinic_signup_tags?: boolean,
    default_anaglyph_orientation?: "red-cyan" | "cyan-red" | "red-green" | "green-red",
    // Present when clinics can set their own patient-pay price
    custom_user_pricing?: {
        commission_percent: number,
        product_live?: string,
        product_test?: string,
        targets: Array<{
            subscription_type: string,
            currency: string,
        }>,
        max_price_cents: Record<string, number>,
    },
}

// global window properties
declare global {
    interface Window {
        app_config: AppConfig,
    }
}

export const default_app_config: AppConfig = {
    id: "nvt",
    default_billing_strategy: "clinic",
    free_trial_length: 62,
    stripe_public_key: "",
    title: "NeuroVisual Trainer",
    stereo_mode: "anaglyph",
    subscription_first: false,
    regimen_progress_expires: "midnight",
    allow_clinic_signup_tags: false,
}

// Set global window.app_config
// @ts-ignore
import app_config from "../../../data/app_config.yml";
if (app_config[process.env.VUE_APP_OPTICALGYM_ID]) {
    window.app_config = app_config[process.env.VUE_APP_OPTICALGYM_ID];
}
else {
    window.app_config = default_app_config;
}

const current_app_config = window.app_config;
export default current_app_config;

// Set-up axios to send app-id on every request
import axios from "axios";
axios.interceptors.request.use((config) => {
    config.headers["X-Opticalgym-App"] = window.app_config.id;
    return config;
});